import React from "react";

class HousekeepingTypesDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.data.length > 0) {
      var housekeeping_types = []
      for (let step = 0; step < this.props.data.length; step++) {
        if (step < 4) {
          housekeeping_types.push(<li key={step}>{this.props.data[step].code}: {I18n.t(this.props.data[step].frequency)}</li> )
        } else if (step === 4){
          housekeeping_types.push(<li key='additional-housekeepign-types'><i>... {` ${I18n.t('more')}`}</i></li>)
        }
      }
      return (
        <ul className="HousekeepingTypesDataType">
            {housekeeping_types}
        </ul>
      );
    } else {
      return (
          <span className="none">{I18n.t('none')}</span>
      )
    }

  }

};

export default HousekeepingTypesDataType